import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FormikChipInput from 'components/formik/ChipInput';
import TextField from 'components/formik/TextField';
import { Field } from 'formik';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  description: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
});

const EmailConfig = () => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <>
      <Typography sx={styles.heading}>{I18n.t('ChatFlowSettings.Recipients')}</Typography>
      <Typography sx={styles.description}>
        {I18n.t('ChatFlowSettings.Email addresses to send notifications to')}
      </Typography>
      <Field
        component={FormikChipInput}
        name="configuration.recipients"
        blurBehavior="add"
        placeholder={I18n.t('ChatFlowSettings.Email')}
      />

      <Typography sx={styles.heading}>{I18n.t('ChatFlowSettings.Subject')}</Typography>
      <Typography sx={styles.description}>
        {I18n.t('ChatFlowSettings.Optional custom subject line')}
      </Typography>
      <Field
        component={TextField}
        name="configuration.subject"
        placeholder={I18n.t('ChatFlowSettings.Subject placeholder')}
      />

      <Typography sx={styles.heading}>{I18n.t('ChatFlowSettings.Email Template')}</Typography>
      <Typography sx={styles.description}>
        {I18n.t(
          'ChatFlowSettings.Optional HTML template. Use {{text}}, {{locale}}, {{page}}, {{context}}, {{timestamp}}',
        )}
      </Typography>
      <Field
        component={TextField}
        name="configuration.template"
        multiline
        rows={6}
        placeholder={I18n.t('ChatFlowSettings.Template placeholder')}
      />
    </>
  );
};

export default EmailConfig;
